<template>
  <div class="invoice-paid-stamp is-hidden-mobile">{{ $t("_.paid") }}</div>
</template>

<script>
export default {
  name: "InvoicePaidStamp"
};
</script>

<style lang="scss" scoped>
.invoice-paid-stamp {
  position: absolute;
  top: -200%;
  right: 5rem;
  border-radius: 0.5rem;
  border: 0.25rem solid currentColor;
  color: $success;
  font-family: $family-monospace;
  font-size: 2.5rem;
  font-weight: 700;
  mix-blend-mode: multiply;
  opacity: 0.25;
  padding: 0.25rem 1rem;
  text-transform: uppercase;
  transform: rotate(-22.5deg);
  user-select: none;
  white-space: nowrap;
}
</style>
